<script>
import AppIcon from "@/features/general/Icons";

const EXPIRY_THRESHOLD_DAYS = 7;
const MS_PER_DAY = 86400000;

export default {
  name: "AppCashbackExpiryBanner",

  components: {
    AppIcon,
  },

  props: {
    balance: {
      type: Object,
      required: true,
    },
  },

  methods: {
    /**
     * Formata valor em centavos para moeda BRL.
     * @param {number} cents valor em centavos
     * @return {string}
     */
    formatCurrency(cents) {
      return (cents / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },

    /**
     * Formata data ISO para exibição no padrão brasileiro.
     * @param {string} isoDate data no formato ISO
     * @return {string}
     */
    formatDate(isoDate) {
      if (!isoDate) {
        return "";
      }

      return new Date(isoDate).toLocaleDateString("pt-BR");
    },
  },

  computed: {
    /**
     * Calcula a diferença em dias entre hoje e a data de expiração.
     * @return {number}
     */
    daysUntilExpiry() {
      if (!this.balance.next_expiration_at) {
        return null;
      }

      const now = new Date();
      const expiresAt = new Date(this.balance.next_expiration_at);
      const diffMs = expiresAt - now;

      return Math.ceil(diffMs / MS_PER_DAY);
    },

    /**
     * Determina se o banner de expiração deve ser exibido.
     * @return {boolean}
     */
    isVisible() {
      const hasAmount = this.balance.next_expiration_amount_cents > 0;
      const isExpiringSoon =
        this.daysUntilExpiry !== null &&
        this.daysUntilExpiry >= 0 &&
        this.daysUntilExpiry <= EXPIRY_THRESHOLD_DAYS;

      return hasAmount && isExpiringSoon;
    },
  },
};
</script>

<template>
  <div
    class="alert alert-warning d-flex align-items-center gap-2"
    role="alert"
    v-if="isVisible"
  >
    <app-icon name="exclamation-triangle" prefix="fa" class="flex-shrink-0" />
    <span>
      <strong>{{ formatCurrency(balance.next_expiration_amount_cents) }}</strong>
      em créditos vencem em {{ daysUntilExpiry }} dia<span v-if="daysUntilExpiry !== 1">s</span>
      ({{ formatDate(balance.next_expiration_at) }}).
      Use agora!
    </span>
  </div>
</template>
